module.exports = __webpack_public_path__ + "static/media/plan-salon.a37cf46a.png";